export default class Base {

    constructor(id, params = {}, result = {}, options = {}) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        // this.$component = document.getElementById(this.id)
    }

    async queryComponent(action, data = {}) {
        let resultData = undefined,
            defaultPostData = {
                sessid: BX.bitrix_sessid(),
            }

        // this.showPreloader()

        let postData = Object.assign({}, defaultPostData, data)
        resultData = await Endorphine.Api.queryComponent(
            this.options.componentName,
            action,
            postData
        )

        // this.hidePreloader()

        return resultData
    }

    get $component() {
        return document.getElementById(this.id)
    }
}
